export const CodeBookVersionFragment = gql`
  fragment CodeBookVersionFragment on CodeBookVersion {
    id
    versionName
    effectiveDate
    importError
    importStatus
    chapterCount
    itemCount
  }
`

export const CodeBookEditorFragment = gql`
  fragment CodeBookEditorFragment on CodeBook {
    id
    name
    latestVersion {
      ...CodeBookVersionFragment
    }
  }
`

export const CodeBookFragment = gql`
  fragment CodeBookFragment on CodeBook {
    id
    importError
    importStartedAt
    importStatus
    name
    versionCount
    latestVersion {
      ...CodeBookVersionFragment
    }
    items {
      ...CodeBookItemFragment
    }
  }
`

export const CodeBookListCardFragment = gql`
  fragment CodeBookListCardFragment on CodeBook {
    id
    importError
    importStartedAt
    importStatus
    chapterCount
    itemCount
    name
    versionCount
    latestVersion {
      id
      versionName
      effectiveDate
    }
  }
`
